import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { JwtUtils } from '../../auth/utilities/jwtUtils';
import { ConsoleLogger } from '../../core/utilities/console-logger';

@Component({
  selector: 'app-hangfire-dashboard',
  templateUrl: './hangfire-dashboard.component.html',
  styleUrls: ['./hangfire-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HangfireDashboardComponent implements OnDestroy {
  url: SafeResourceUrl = '';

  constructor(private sanitizer: DomSanitizer) {
    ConsoleLogger.logInfo('Cookies Before', document.cookie);
    const expires = new Date();
    expires.setMinutes(expires.getMinutes() + 30);
    const cookie = `HangfireCookie=${JwtUtils.accessToken};Path=/; SameSite=None; Secure;Domain=${environment.apiDomain};expires=${expires.toUTCString()}`;
    ConsoleLogger.logInfo('Cookie to add', cookie);

    document.cookie = cookie;
    ConsoleLogger.logInfo('Cookies After', document.cookie);

    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.hangfireDashboardUrl}`);
    ConsoleLogger.logInfo(`Hangfire URL: ${this.url}`);
  }

  ngOnDestroy() {
    // remove cookie HangFireCookie
    document.cookie = 'HangFireCookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
  }

}



// WEBPACK FOOTER //
// ./src/app/developer/hangfire-dashboard/hangfire-dashboard.component.ts